/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Pit2_DInputs */

const en_to_typescript_pit2_d = /** @type {(inputs: To_Typescript_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The generated name is RootObject, not Root and not something derived from your data. Rename it after copying to match your domain, and remember to update the references from any nested interfaces if you also rename those.`)
};

const ko_to_typescript_pit2_d = /** @type {(inputs: To_Typescript_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성되는 이름은 RootObject이며, Root도 아니고 데이터에서 파생된 것도 아닙니다. 복사한 뒤 도메인에 맞게 이름을 바꾸고, 중첩 인터페이스 이름도 바꾼다면 그것을 참조하는 곳도 함께 고치는 것을 잊지 마세요.`)
};

const ja_to_typescript_pit2_d = /** @type {(inputs: To_Typescript_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成される名前は RootObject で、Root でもデータから導かれたものでもありません。コピー後にドメインに合わせて名前を変え、ネストしたインターフェース名も変えるなら、それを参照している箇所も直すのを忘れないでください。`)
};

/**
* | output |
* | --- |
* | "The generated name is RootObject, not Root and not something derived from your data. Rename it after copying to match your domain, and remember to update the..." |
*
* @param {To_Typescript_Pit2_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_pit2_d = /** @type {((inputs?: To_Typescript_Pit2_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Pit2_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_pit2_d(inputs)
	if (locale === "ko") return ko_to_typescript_pit2_d(inputs)
	return ja_to_typescript_pit2_d(inputs)
});